export default __webpack_public_path__ + "static/media/SocialNotify.94a1b07b.mp3";